import { ICancelBroadbandForm, IFormData } from "@features/CancelBroadband/interface/ICancelBroadbandForm";
import { objectToQueryQuestionMark } from "@utils/url";
import { ITerminationDetailsResponse } from "@features/CancelBroadband/mappers/getTerminationDetails";
import { getTerminationDetails, postTerminationRequest } from "@api-routes/bff";
import { useEffect, useState } from "react";
import { useFetch } from "@common/hook/useFetch";
import { addDays } from "date-fns";
import { formatDateLong } from "@utils/dateFormat";

interface IParams {
    formData: ICancelBroadbandForm;
    getTerminationRequest(): void;
}

export const useCancelBroadbandDetails = (props: IParams) => {
    const { formData, getTerminationRequest } = props;

    const [terminationDetails, setTerminationDetails] = useState<ITerminationDetailsResponse>();
    const [getTerminationDetailsState, { get }] = useFetch();
    const [postTerminationRequestState, { post }] = useFetch();

    useEffect(() => {
        const queryString = objectToQueryQuestionMark(formData as IFormData);

        const shouldOverride = process.env.OVERRIDE_BROADBAND_EQUIPMENT_RETURN_DATE?.trim().toLowerCase() === "true";
        const delay = Number(process.env.BROADBAND_EQUIPMENT_RETURN_DELAY_DAYS);

        get<ITerminationDetailsResponse>(getTerminationDetails(queryString)).then(
            (terminationDetailsResponse) =>
                terminationDetailsResponse &&
                setTerminationDetails(
                    shouldOverride && !Number.isNaN(delay)
                        ? {
                              ...terminationDetailsResponse,
                              equipments: terminationDetailsResponse.equipments.map((equipment) => ({
                                  ...equipment,
                                  collectBeforeAt: formatDateLong(
                                      addDays(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0), delay)
                                  ),
                              })),
                          }
                        : terminationDetailsResponse
                )
        );
    }, [formData, get]);

    const submitTerminationRequest = async () => {
        await post(postTerminationRequest(), {
            body: formData,
        }).then((response) => {
            if (response) {
                getTerminationRequest();
            }
        });
    };

    const isLoading = getTerminationDetailsState.isLoading || postTerminationRequestState.isLoading;
    const error = getTerminationDetailsState.error ?? postTerminationRequestState.error;

    return { terminationDetails, submitTerminationRequest, error, isLoading };
};
